'use client';

import Link from 'next/link';
import { useLenis } from 'lenis/react';
import { usePathname } from 'next/navigation';
import { useContentSize } from '@/components/SizeProvider';
import { useIsSafari } from '@/lib/hooks/useIsSafari';
import ButtonRight from './ButtonRight';
import { MAIL_CONFIG } from '@/lib/config';

const ContactInfo = () => {
  const { width: widthContent, height: heightContent } = useContentSize();
  const size = heightContent / 9 + widthContent / 16;
  const isSafari = useIsSafari();
  const lenis = useLenis();
  const pathname = usePathname();
  const isBlogPage = pathname?.startsWith('/blog') ?? false;

  const _goList = () => {
    window.location.href = `mailto:${MAIL_CONFIG}`;
  };

  const _onBlogClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    // Already on /blog: re-navigating remounts the index and reshuffles the
    // randomly-placed cards. Cancel the navigation and just scroll to the top.
    if (pathname === '/blog') {
      event.preventDefault();
      if (lenis) lenis.scrollTo(0);
      else window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <div className={'contact-wrapper'} style={{ fontWeight: isSafari ? 500 : 700 }}>
      <h2 className='text-gray letter-scrambler'>{'\\\\SOCIALS\\\\'}</h2>
        <a 
          href="https://www.instagram.com/theotherlab.co/" 
          target="_blank" 
          rel="noopener noreferrer" 
          className='letter-scrambler social-item'
          style={{ fontSize: widthContent / 160 }}
        >
          INSTAGRAM
        </a>
        {/* <Link 
          href="/blog" 
          onClick={_onBlogClick} 
          className={`letter-scrambler social-item ${isBlogPage ? 'social-item-active' : ''}`}
          style={{ fontSize: widthContent / 160 }}
        >
          BLOG
        </Link> */}
        
        <p className={isSafari ? "text-gray-safari2" : 'text-gray'}>{"<>"}</p>
        <h2 className='text-gray letter-scrambler'>{'\\\\REACH\\\\'}</h2>
        <div>
          <p className='letter-scrambler'>195 PEARL'S HILL TERRACE</p>
          <p className='letter-scrambler'>#03-76 SINGAPORE 168976</p>
        </div>
        <p className='text-gray final-or letter-scrambler'>{'< OR >'}</p>
      <ButtonRight goList={_goList} size={size} style={{ height: heightContent / 22 }} />
    </div>
  )
};

export default ContactInfo
